import React from 'react'
import {Grid, withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import Button from 'components/Button';

const style = theme => ({
    root: {},
    item: {
        width: theme.components.popup.buttons.width,
        '&:nth-child(2)': {
            marginRight: theme.spacing(1)
        },
        '&:nth-child(3)': {
            marginLeft: theme.spacing(1)
        }
    }
})

function SingleButton(
    {
        className,
        classes,
        label,
        onClick,
        buttonType,
        disabled,
        justify="flex-end",
        variant,
        before,
        after,
    }) {
    return (
        <Grid container className={className} justifyContent={justify}>
            <Grid item>{before}</Grid>
            <Grid item className={classes.item}>
                <Button
                    fullWidth
                    onClick={onClick}
                    variant={variant}
                    disabled={disabled}
                >
                    {label}
                </Button>
            </Grid>
            <Grid item>{after}</Grid>
        </Grid>
    )
}

SingleButton.propTypes = {
    className: PropTypes.string,
    classes: PropTypes.any,
    variant: PropTypes.oneOf([ 'text', 'outlined', 'contained']),
    label: PropTypes.string,
    justify: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool
}

SingleButton.defaultProps = {}

export default withStyles(style)(SingleButton);